import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6613505f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex flex-col gap-2 text-left",
  "data-testid": "coverage-status-filter"
}
const _hoisted_2 = { class: "text-sm font-semibold text-textPrimary" }
const _hoisted_3 = { class: "flex flex-wrap gap-2" }
const _hoisted_4 = ["aria-pressed", "data-testid", "onClick"]
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = {
  key: 0,
  class: "text-xs text-[#68688D]",
  "data-testid": "coverage-status-counts-hint"
}
const _hoisted_7 = {
  key: 1,
  class: "text-xs text-[#68688D]",
  "data-testid": "coverage-status-covered-hint"
}

import { computed } from 'vue'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import type { CoverageCounts } from '@/Network/Types/Responses/CoverageResponses'
import { COVERAGE_STATUS_SHORT_LABELS } from '@/utils/coverage'
import { COVERAGE_STATUS_ORDER } from '@/utils/coverageFilters'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoverageStatusFilterChips',
  props: {
    modelValue: {},
    counts: { default: null },
    label: { default: 'Vaga do plantão' },
    countsHint: { default: null }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;




const SELECTED_CLASSES: Record<CoverageStatus, string> = {
  [CoverageStatus.OPEN]: 'border-[color:var(--st-open-stripe,#F18F1B)] bg-[var(--st-open-bg,#FEF3E7)] text-[color:var(--st-open-text,#8A4B00)]',
  [CoverageStatus.DOCTOR]: 'border-primary bg-primary5 text-primary40',
  [CoverageStatus.UNIDENTIFIED]: 'chip-unidentified border-[#68688D] text-[#3E3E5A]'
}

const isSelected = (status: CoverageStatus) => props.modelValue.includes(status)
const formatCount = (value: number | undefined) => (value ?? 0).toLocaleString('pt-BR')

function toggle(status: CoverageStatus) {
  const next = isSelected(status)
    ? props.modelValue.filter((item) => item !== status)
    : [...props.modelValue, status]
  emit('update:modelValue', COVERAGE_STATUS_ORDER.filter((item) => next.includes(item)))
}

const coveredHint = computed(() => {
  const covered =
    props.modelValue.length === 2 &&
    isSelected(CoverageStatus.DOCTOR) &&
    isSelected(CoverageStatus.UNIDENTIFIED)
  if (!covered) return null
  const total = props.counts ? props.counts.DOCTOR + props.counts.UNIDENTIFIED : null
  return `Selecionados: Com médico + Ocupado s/ ident.${total !== null ? ` (= plantões cobertos, ${formatCount(total)})` : ''}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COVERAGE_STATUS_ORDER), (status) => {
        return (_openBlock(), _createElementBlock("button", {
          key: status,
          type: "button",
          "aria-pressed": isSelected(status),
          class: _normalizeClass(["inline-flex items-center gap-2 rounded-full border border-solid px-3 py-1 text-sm font-semibold transition-colors", isSelected(status) ? SELECTED_CLASSES[status] : 'border-lightGray30 bg-white text-textPrimary']),
          "data-testid": `coverage-status-chip-${status.toLowerCase()}`,
          onClick: ($event: any) => (toggle(status))
        }, [
          _createTextVNode(_toDisplayString(_unref(COVERAGE_STATUS_SHORT_LABELS)[status]) + " ", 1),
          (_ctx.counts)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "rounded-full bg-white/70 px-1.5 text-xs",
                "data-testid": `coverage-status-count-${status.toLowerCase()}`
              }, _toDisplayString(formatCount(_ctx.counts[status])), 9, _hoisted_5))
            : _createCommentVNode("", true)
        ], 10, _hoisted_4))
      }), 128))
    ]),
    (_ctx.counts && _ctx.countsHint)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.countsHint), 1))
      : _createCommentVNode("", true),
    (coveredHint.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(coveredHint.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})